import React from "react";

import { Container } from "react-bootstrap";

import { termsEn } from "@/data/terms-en.html";
import { termsFr } from "@/data/terms-fr.html";

import i18n from "../i18n";

const TermsOfService = () => {
  const { language } = i18n;

  return (
    <Container>
      {language === "fr" ? (
        <div dangerouslySetInnerHTML={{ __html: termsFr }} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: termsEn }} />
      )}
    </Container>
  );
};

export default TermsOfService;
